// Vue 3 compatible Intercom plugin
const IntercomPlugin = {
  install(app, options) {
    const { appId } = options;

    if (!appId) {
      return;
    }

    // Initialize Intercom state
    const intercomState = {
      ready: false,
      visible: false,
      unreadCount: 0,
    };

    // Load Intercom script
    const loadIntercom = () => {
      if (window.Intercom) {
        intercomState.ready = true;
        return;
      }

      const intercomSettings = { app_id: appId };

      window.intercomSettings = intercomSettings;

      const script = document.createElement('script');
      script.async = true;
      script.src = `https://widget.intercom.io/widget/${appId}`;

      script.onload = () => {
        intercomState.ready = true;

        // Set up event listeners

        window.Intercom('onShow', () => {
          intercomState.visible = true;
        });

        window.Intercom('onHide', () => {
          intercomState.visible = false;
        });

        window.Intercom('onUnreadCountChange', unreadCount => {
          intercomState.unreadCount = unreadCount;
        });
      };

      document.head.appendChild(script);
    };

    // Intercom API wrapper
    const intercom = {
      ready: intercomState.ready,
      visible: intercomState.visible,
      unreadCount: intercomState.unreadCount,

      boot(options = {}) {
        if (!window.Intercom) return;
        window.Intercom('boot', { app_id: appId, ...options });
      },

      shutdown() {
        if (!window.Intercom) return;
        window.Intercom('shutdown');
      },

      update(options = {}) {
        if (!window.Intercom) return;
        window.Intercom('update', options);
      },

      show() {
        if (!window.Intercom) return;
        window.Intercom('show');
      },

      hide() {
        if (!window.Intercom) return;
        window.Intercom('hide');
      },

      showMessages() {
        if (!window.Intercom) return;
        window.Intercom('showMessages');
      },

      showNewMessage(content) {
        if (!window.Intercom) return;
        window.Intercom('showNewMessage', content);
      },

      trackEvent(name, metadata) {
        if (!window.Intercom) return;
        window.Intercom('trackEvent', name, metadata);
      },

      getVisitorId() {
        if (!window.Intercom) return;
        return window.Intercom('getVisitorId');
      },

      startTour(tourId) {
        if (!window.Intercom) return;
        window.Intercom('startTour', tourId);
      },
    };

    // Make $intercom available globally
    app.config.globalProperties.$intercom = intercom;

    // Provide for composition API
    app.provide('intercom', intercom);

    // Load the script
    loadIntercom();
  },
};

export default function installIntercom(app, appId) {
  if (!appId) {
    return;
  }

  app.use(IntercomPlugin, { appId });
}
